<template>
  <div class="my-6">
    <form method="post">
      <div class="form-container">
        <div class="form-content">
          <div class="top-title">
            <b>Your Credit Card Will Be Charged By:</b><br />
            <span class="descriptor">$!DESCRIPTOR</span>
          </div>
          <div class="form-label">Full Name on a Card</div>
          <floating-input
            id="card_printed_name"
            placeholder="Full name on Card"
            name="card_printed_name"
            type="text"
            maxlength="64"
            autocomplete="off"
          >
          </floating-input>
          <div class="form-label">
            Card number<span class="form-label-comment"
              >The 13-19 digits on the front of your card</span
            >
          </div>
          <floating-input
            id="credit_card_number"
            placeholder="Card number"
            name="credit_card_number"
            type="text"
            maxlength="19"
            autocomplete="off"
          >
          </floating-input>
          <div class="form-label-nobottom">
            <span class="form-label-expiration">Expiration date</span>
            <span class="form-label-cvv">Card verification value</span>
          </div>
          <div class="form-label-notop">
            <div class="flex">
              <v-select
                :options="months"
                @input="handleMonthChanged"
                :value="monthSelected"
              >
              </v-select>
              <input type="hidden" name="expire_month" id="expire_month" v-model="monthSelected.value"/>
              <v-select
                :options="years"
                @input="handleYearChanged"
                :value="yearSelected"
              >
              </v-select>
              <input type="hidden" name="expire_year" id="expire_year" v-model="yearSelected"/>
              <floating-input
                placeholder="CVV"
                name="cvv2"
                id="cvv2"
                type="text"
                maxlength="4"
                autocomplete="off"
              >
              </floating-input>
            </div>
          </div>
          <div class="legal">$!LEGAL</div>
          <div class="validation-error" id="valdiation_error"></div>
        </div>
        <div class="ssl-footer">You will be charged {{ total | currency }}</div>
      </div>
      <input
        class="form-submit"
        name="bSubmit"
        id="bSubmit"
        type="button"
        value="Complete Transaction"
      />
      <input
        type="hidden"
        name="serial_number"
        id="serial_number"
        value="$!SERIAL"
      />
      <input
        type="hidden"
        name="endpointid"
        id="endpointid"
        value="$!ENDPOINTID"
      />
      <input
        type="hidden"
        name="action"
        id="action"
        :value="`${appUrl}api/order/1/checkout`"
      />
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_TOTAL } from "../../../store/cart/types";

export default {
  data: () => {
    return {
      appUrl: window.appUrl,
      months: [
        { value: "01", label: "Jan" },
        { value: "02", label: "Feb" },
        { value: "03", label: "Mar" },
        { value: "04", label: "Apr" },
        { value: "05", label: "May" },
        { value: "06", label: "Jun" },
        { value: "07", label: "Jul" },
        { value: "08", label: "Aug" },
        { value: "09", label: "Sep" },
        { value: "10", label: "Oct" },
        { value: "11", label: "Nov" },
        { value: "12", label: "Dec" },
      ],
      years: [],
      monthSelected: { value: "01", label: "Januray" },
      yearSelected: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapGetters({
      total: GET_TOTAL,
    }),
  },
  methods: {
    handleMonthChanged(val) {
      this.monthSelected = val;
    },
    handleYearChanged(val) {
      this.yearSelected = val;
    },
    generateArrayOfYears() {
      var min = new Date().getFullYear();
      var max = min + 10;
      var years = [];

      for (var i = min; i <= max; i++) {
        years.push(i);
      }
      return years;
    },
  },
  created() {
    this.years = this.generateArrayOfYears();
  },
  mounted() {
    const event = new Event("load-paragon");
    window.dispatchEvent(event);
  },
};
</script>

<style></style>
